import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import { TagsOutlined } from "@ant-design/icons";
import React, { useImperativeHandle, useState } from "react";
import { CurrencyFormat } from "../../../components/FormattersTS";
import { Spin } from "antd";
import HelpLabel from "../../../components/HelpLabel";
const MarketplaceOnDemandStatsWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadMarketplaceOnDemandStats();
    };
    const loadMarketplaceOnDemandStats = () => {
        setLoading(true);
        axios.get(`/admin/v1/dashboard/marketplace-on-demand-stats/${props.date}`)
            .then(response => {
            setData(response.data);
        }).catch(error => {
            setData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setLoading(false);
        });
    };
    const { consignmentCount, onDemandCount, totalEstCost, avgEstCost } = data ?? {};
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-coral", children: _jsx(TagsOutlined, {}) }), consignmentCount
                    ? _jsxs("h2", { className: "widget-value", children: [consignmentCount, _jsxs("span", { className: "small", children: ["/", onDemandCount, " on demand"] })] })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Marketplace Deliveries", helpText: _jsx("p", { children: "The total number of deliveries you have on the marketplace.  This includes deliveries planned to hired vehicles and on demand deliveries." }) }) }), _jsx("div", { className: "widget-separator" }), (totalEstCost && avgEstCost)
                    ? _jsxs("h2", { className: "widget-value", children: [_jsx(CurrencyFormat, { value: totalEstCost, roundToDollars: true }), _jsxs("span", { className: "small", children: ["\u00A0(avg: ", _jsx(CurrencyFormat, { value: avgEstCost, roundToDollars: true }), ")"] })] })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Est. total cost", helpText: _jsx("p", { children: "An estimate of the cost for the above marketplace deliveries." }) }) })] }) }));
};
export default React.forwardRef(MarketplaceOnDemandStatsWidget);
